<template lang="pug">
    .options-menu
        .controls-wrapper
            .nav-buttons
                template(v-if="!isMobile")
                  .button.prev(@click="onUspPrevClick",
                    @mouseenter="uspTooltipActive = true",
                    @mouseleave="uspTooltipActive = false",
                    ga-category="scene",
                    ga-label="prevUsp")
                  .button.next(@click="onUspNextClick",
                    @mouseenter="uspTooltipActive = true",
                    @mouseleave="uspTooltipActive = false",
                    ga-category="scene",
                    ga-label="nextUsp")
                template(v-else)
                  .button.prev(@click="onUspPrevClick",
                    ga-category="scene",
                    ga-label="prevUsp")
                  .button.next(@click="onUspNextClick",
                    ga-category="scene",
                    ga-label="nextUsp")
                .button.interior-exterior(@click="onToggleCabineViewClick",
                  v-if="isMobile",
                  ga-category="scene",
                  ga-label="interior") {{!insideCabine ? "Интерьер" : "Экстерьер"}}
                .usp-toolip(v-if='uspTooltipActive')
                    .text Просмотр преимуществ
                    .corner

            colors-slider(v-if="activeSlider === 'color'", :slides="carColors" :activeSlide="carColor", @select="setCarColor($event)")
            colors-slider(v-if="activeSlider === 'color-interior'", :slides="interiorColors", :activeSlide="carInteriorColor", @select="setCarInteriorColor($event)")
            wheels-slider(v-if="activeSlider === 'wheels'", :slides="carWheelsSlides", :activeSlide="carWheels", @select="setCarWheels($event)")

            .options-buttons
                .button.interior(@click="showSlider('color-interior')",
                  v-if="carModel === 'jetta'",
                  :class="{light: activeSlider === 'color-interior'}",
                  @mouseenter="seatTooltipActive = true",
                  @mouseleave="seatTooltipActive = false",
                  ga-category="scene",
                  ga-label="interiorColor")
                .button.wheels(@click="showSlider('wheels')",
                  :class="{light: activeSlider === 'wheels'}",
                  v-if="carModel === 'polo'",
                  @mouseenter="wheelsTooltipActive = true",
                  @mouseleave="wheelsTooltipActive = false",
                  ga-category="scene",
                  ga-label="wheels")
                .button.color(@click="showSlider('color')",
                  :class="{light: activeSlider === 'color'}",
                  @mouseenter="colorTooltipActive = true",
                  @mouseleave="colorTooltipActive = false",
                  ga-category="scene",
                  ga-label="carColor")
                    .selected-color(:style="{backgroundColor: carColor ? carColor.colors[0] : null}")

                .usp-toolip.seat(v-if='seatTooltipActive && !isMobile')
                  .text Поменять обивку салона
                  .corner

                .usp-toolip.wheels(v-if='wheelsTooltipActive && !isMobile')
                  .text Поменять диски
                  .corner

                .usp-toolip.color(v-if='colorTooltipActive && !isMobile')
                  .text Поменять цвет кузова
                  .corner

</template>
<script>
import ColorsSlider from "./ColorsSlider";
import WheelsSlider from "./WheelsSlider";
import {mapActions, mapGetters} from "vuex";
import isMobileMixin from "../mixins/isMobileMixin";

export default {
  name: 'OptionsMenu',
  mixins: [isMobileMixin],
  components: {WheelsSlider, ColorsSlider},
  props: ['uspWindowVisible'],
  data () {
    return {
      uspTooltipActive: false,
      seatTooltipActive: false,
      colorTooltipActive: false,
      wheelsTooltipActive: false,
      activeSlider: null,
      interiorColors: [
        {
          id: 2,
          title: 'Черный Titanium',
          colors: ['#212025']
        },
        {
          id: 1,
          title: 'Бежевый интерьер',
          colors: ['#CFBBA0'],
        },
      ],
    }
  },

  created () {
    this.setCarColor(this.carColors[0])
    this.setCarInteriorColor(this.interiorColors[0])
    this.setCarWheels(this.carWheelsSlides[0])
  },

  mounted() {
    this.uspTooltipActive = this.isMobile
    document.addEventListener('touchstart', this.onDocumentTouch)
  },

  destroyed () {
    document.removeEventListener('touchstart', this.onDocumentTouch)
  },

  computed: {
    ...mapGetters(['carColor', 'carInteriorColor', 'insideCabine', 'uspData', 'carModel', 'carWheels']),

    carColors() {
      const colors = {
        jetta: [
          {
            id: 3,
            title: 'Синий "Silk", металлик',
            colors: ['#50688D']
          },
          {
            id: 2,
            title: 'Белый "Pure"',
            colors: ['#FFFFFF']
          },
          {
            id: 1,
            title: 'Оранжевый "Habanero", металлик',
            colors: ['#D55831'],
          },
          {
            id: 4,
            title: 'Серый "Platinum", металлик',
            colors: ['#3F4140']
          },
          {
            id: 5,
            title: 'Чёрный "Deep", перламутр',
            colors: ['#161A26']
          },
          {
            id: 6,
            title: 'Серебристый "Pyrit", металлик',
            colors: ['#BABBBD']
          }
        ],
        polo: [
          {
            id: 7,
            title: 'Красный "Ruby", металлик',
            colors: ['#902917']
          },
          {
            id: 12,
            title: 'Белый "Pure"',
            colors: ['#FFFFFF']
          },
          {
            id: 10,
            title: 'Синий "Reef", металлик',
            colors: ['#274B93']
          },
          {
            id: 9,
            title: 'Серый "Indium", металлик',
            colors: ['#BABBBD']
          },
          {
            id: 5,
            title: 'Бежевый "Titanium", металлик',
            colors: ['#716D64']
          },
          {
            id: 6,
            title: 'Коричневый "Toffee Brown", металлик',
            colors: ['#4E3A2F']
          },
          {
            id: 8,
            title: 'Серебристый "Tungsten", металлик',
            colors: ['#C8C8C6']
          },
          {
            id: 11,
            title: 'Черный "Deep", перламутр',
            colors: ['#2B2F2E']
          },
          {
            id: 1,
            title: 'Бежевый "Titanium", металлик / Чёрный "Deep"',
            colors: ['#DFE4E8', '#161925']
          },
          {
            id: 2,
            title: 'Белый "Pure" / Чёрный "Deep", металлик',
            colors: ['#FFFFFF', '#161925']
          },
          {
            id: 3,
            title: 'Серебристый "Tungsten", металлик / Чёрный "Deep"',
            colors: ['#C8C8C6', '#161925'],
          },
          {
            id: 4,
            title: 'Синий "Reef", металлик / Чёрный "Deep"',
            colors: ['#274B93', '#161925']
          }
        ]
      }

      return colors[this.carModel]
    },

    carWheelsSlides() {
      return [
        {
          id: 3,
          title: 'Легкосплавные диски 16’’ Las Minas, черные',
          url: '/pics/wheels-minas-black.png'
        },
        {
          id: 1,
          title: 'Легкосплавные диски 15’’ Akona',
          url: '/pics/wheels-akona.png'
        },
        {
          id: 2,
          title: 'Легкосплавные диски 16’’ Las Minas',
          url: '/pics/wheels-minas.png'
        }
      ]
    }
  },

  watch: {
  },

  methods: {
    ...mapActions(['nextUsp', 'prevUsp', 'setCarColor', 'setCarInteriorColor', 'setCarWheels', 'setInsideCabine', 'hideUspWindow']),

    onDocumentTouch() {
      this.uspTooltipActive = false
    },

    onToggleCabineViewClick() {
      this.hideUspWindow()
      this.setInsideCabine(!this.insideCabine)
    },

    showSlider(type) {
      this.activeSlider = this.activeSlider === type ? null : type
    },

    onUspPrevClick() {
      this.uspTooltipActive = false
      this.prevUsp()
    },

    onUspNextClick() {
      this.uspTooltipActive = false
      this.nextUsp()
    }
  }
}
</script>